"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.warn = exports.errorPos = exports.withErrorConsole = void 0;
const chalk_1 = __importDefault(require("chalk"));
function withErrorConsole(fn) {
    return function (...args) {
        try {
            return fn(...args);
        }
        catch (error) {
            if (error instanceof Error) {
                error = error.message.replace(/^Error: /, '');
            }
            console.log(`error: ${error}`);
            process.exit();
        }
    };
}
exports.withErrorConsole = withErrorConsole;
function errorPos(str, items, index) {
    index = Number(index);
    const errorStr = items[index];
    let baseIndex = 0;
    let position = -1;
    for (let i = 0, len = items.length; i < len; i++) {
        if (i !== index && items[i] === errorStr) {
            baseIndex = str.indexOf(errorStr, baseIndex) + 1;
        }
        if (i === index) {
            position = str.indexOf(errorStr, baseIndex);
            break;
        }
    }
    const errorStrLen = errorStr.length;
    const mark = `${chalk_1.default.bgYellow('|')} `;
    str = str.slice(0, position) + chalk_1.default.bgYellow.red(errorStr) + str.slice(position + errorStrLen);
    return `${mark}${str}\n${mark}${' '.repeat(position)}${chalk_1.default.yellow('^')}`;
}
exports.errorPos = errorPos;
function warn(info) {
    console.log(`warn: ${info}`);
}
exports.warn = warn;
